import { TrackedConditionalLink } from 'components/Link';
import { Body } from 'components/Text/Body';
import { BodySmall } from 'components/Text/BodySmall';
import { RichTextHeadline } from 'components/Text/RichTextHeadline';
import { CmsApiImageBlockData } from 'modules/cms/api/types/blocks/CmsApiImageBlock';
import { colors } from 'theme/theme';

import { CmsImageBlockImageOrFigureContainer } from './CmsImageBlock.styled';
import { CmsImageBlockImage } from './CmsImageBlockImage';

type Props = {
  data: CmsApiImageBlockData;
  className?: string;
  fullWidthLayout?: boolean;
  blockIndex: number;
  pageUpdated: string;
};

export function CmsImageBlock({
  data: { headline, subtitle, image, url, keepDimensions },
  className,
  fullWidthLayout,
  blockIndex,
  pageUpdated,
}: Props) {
  return (
    <figure
      className={className}
      style={{ margin: 0, width: '100%' }}
      data-qa-id="cms-image-block"
      data-qa-keep-dimensions={Boolean(keepDimensions)}
    >
      {(headline || subtitle) && (
        <figcaption style={{ marginBottom: 48 }}>
          {headline && (
            <RichTextHeadline textAlignCenter={fullWidthLayout}>
              {headline}
            </RichTextHeadline>
          )}
          {subtitle && (
            <Body
              analyticsData={{
                eventName: 'CMS Block',
                eventProperties: {
                  block_position: blockIndex,
                  block_type: 'Image',
                },
              }}
              textAlign={fullWidthLayout ? 'center' : 'left'}
              dangerouslySetInnerHTML={{
                __html: subtitle,
              }}
            />
          )}
        </figcaption>
      )}

      <CmsImageBlockImageOrFigureContainer
        as={headline || subtitle ? 'figure' : 'div'}
      >
        <TrackedConditionalLink
          link={url}
          eventName="CMS Block"
          eventProperties={{
            block_position: blockIndex,
            block_type: 'Image',
            cta_type: 'Image',
            page_updated: pageUpdated,
          }}
          aria-label={image.altText || getText('Follow image link')}
        >
          <CmsImageBlockImage
            image={image}
            keepDimensions={keepDimensions}
            fullWidthLayout={Boolean(fullWidthLayout)}
          />
        </TrackedConditionalLink>

        {image.caption && (
          <div style={{ marginTop: 8 }}>
            <BodySmall color={colors.lightContentGrey} tag="figcaption">
              {image.caption}
            </BodySmall>
          </div>
        )}
      </CmsImageBlockImageOrFigureContainer>
    </figure>
  );
}
